import { LogIn } from "react-feather";
import man from "../../../assets/images/dashboard/profile.png";
import { LI, UL, Image, P } from "../../../AbstractElements";
import { LogOut } from "../../../Constant";
import { useAdmin } from "../../../context/AdminContext";

const UserHeader = () => {
  const { admin } = useAdmin();  

  const profile = admin?.avatar || man;
  const name = admin?.name;

  const Logout = () => {
    localStorage.removeItem("token");
    window.location.href = "/login";
  };

  const roleMap = {
    ADMIN: "Administrador",
    ADMIN_ASSISTANT: "Auxiliar Administrativo",
    ASSISTANT: "Auxiliar",
  };

  const displayRole = roleMap[admin?.role] || "";

  
  return (
    <li className="profile-nav onhover-dropdown pe-0 py-0">
      <div className="media profile-media">
        <Image
          attrImage={{
            className: "b-r-10 m-0",
            src: profile,
            alt: "profile",
          }}
        />
        <div className="media-body">
          <span>{name}</span>
            {displayRole && (
            <P attrPara={{ className: "mb-0 font-roboto" }}>
              {displayRole} <i className="middle fa fa-angle-down"></i>
            </P>
          )} 
        </div>
      </div>
      <UL attrUL={{ className: "simple-list profile-dropdown onhover-show-div" }}>
        <LI attrLI={{ onClick: Logout }}>
          <LogIn />
          <span>{LogOut}</span>
        </LI>
      </UL>
    </li>
  );
};

export default UserHeader;
